export default class AccountDataService {
    static extractAccountData(accountData) {
        if (!accountData) {
            return null;
        }

        return {
            email: accountData.email?.emailAddress,
            credits: accountData.credits,
            cmeType: accountData.cmeType,
            name: accountData.name,
            userName: accountData.userName
        };
    }
}
